import request from '@/utils/request'

const getList = (data) => {
  const { title, page, limit, sort } = data

  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${sort.type}`
  if(title) query += `&title=${encodeURI(title)}`
  return request({
    url: `/api/notification-messages?${query}`,
    method: 'get'
  })
}


const create = (data) => {
  return request({
    url: `/api/notification-messages`,
    method: 'post',
    data
  })
}

const remove = (id) => {
  return request({
    url: `/api/notification-messages/${id}`,
    method: 'delete'
  })
}

const download = () => {
  return request({
    url: `/api/notification-messages/download`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  getList,
  create,
  remove,
  download
}
